import { useState, useEffect } from 'react';

const AnimatedTitle: React.FC = () => {
  const titles = ['Developer', 'Engineer'];
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(150);

  useEffect(() => {
    const currentTitle = titles[currentTitleIndex];
    
    if (isDeleting) {
      // Delete characters one by one
      if (charIndex > 0) {
        const timeout = setTimeout(() => {
          setDisplayText(currentTitle.substring(0, charIndex - 1));
          setCharIndex(charIndex - 1);
          setTypingSpeed(100); // Faster when deleting
        }, 50);
        return () => clearTimeout(timeout);
      } else {
        // Switch to next title when deletion is complete
        setIsDeleting(false);
        setCurrentTitleIndex((prevIndex) => (prevIndex + 1) % titles.length);
        setCharIndex(0);
      }
    } else {
      // Type characters one by one
      if (charIndex < currentTitle.length) {
        const timeout = setTimeout(() => {
          setDisplayText(currentTitle.substring(0, charIndex + 1));
          setCharIndex(charIndex + 1);
          setTypingSpeed(100 + Math.random() * 50); // Slight variation in typing speed
        }, typingSpeed);
        return () => clearTimeout(timeout);
      } else {
        // Start deleting after a pause when typing is complete
        const timeout = setTimeout(() => {
          setIsDeleting(true);
        }, 2000);
        return () => clearTimeout(timeout);
      }
    }
  }, [charIndex, currentTitleIndex, isDeleting, typingSpeed]);

  return (
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground relative">
      Software <span className="text-primary">{displayText}</span>
      <span className="inline-block w-2"></span>
      <span 
        className="inline-block w-1 h-8 -mb-1 bg-primary animate-[pulse_1s_ease-in-out_infinite]"
        style={{
          verticalAlign: 'middle',
          animationTimingFunction: 'step-end',
          opacity: 0.8,
        }}
      />
    </h2>
  );
};

export default AnimatedTitle;
